// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__Dju8j","info":"Panel_info__Uuxqo","btns":"Panel_btns__DR3TH","button":"Panel_button__DrPqM"};